/** @jsxImportSource react */
import type { SVGProps } from 'react';
const LegacyEmptyFallingAirplane = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 140 140" {...props}>
    <path
      fill="#1E2024"
      fillOpacity={0.06}
      d="m22.603 107.426 36.592-5.208 10.085-.498 18.985-.003 30.324 8.202-13.964 1.883-81.898-1.989c-1.473-.036-1.584-2.18-.124-2.387"
    />
    <path
      fill="#E2E4EA"
      d="M95.523 29.245c-5.12 1.994-16.291 6.218-22.215 7.505a2.1 2.1 0 0 0-1.29.855l-1.702 2.474 38.571 71.249 14.765.671 2.381-4.292-2.316.674a7 7 0 0 1-3.444.121l-2.143-.465a4.86 4.86 0 0 1-2.569-1.481l-1.377-1.515a4.8 4.8 0 0 1-1.156-2.264c-4.332-21.023-12.145-60.91-14.272-71.79-.287-1.47-1.83-2.288-3.233-1.742"
    />
    <path stroke="#000" strokeLinecap="round" d="m108.196 78.581 2.78 14.014" />
    <path
      fill="#CBCFD8"
      d="m72.015 37.612-5.69 8.269 32.92 56.309 11.41 7.27 11.381 1.069 6.81-3.15-7.255 2.21-11.827-2.008-4.639-5.186-32.25-64.726a.5.5 0 0 0-.86-.057"
    />
    <path stroke="#000" strokeLinecap="round" d="m77.712 47.43 3.384 6.525" />
    <path
      fill="#CBCFD8"
      d="m26.739 70.884 27.656-25.95 40.99 59.666-68.11-30.437c-1.299-.581-1.58-2.3-.536-3.28"
    />
    <path
      fill="#E2E4EA"
      d="M64.793 37.106 10.428 39.11c-2.273.084-3.186 2.986-1.361 4.332l81.845 60.355 10.371 6.977a5.97 5.97 0 0 0 3.184 1.013l18.008.45a4.03 4.03 0 0 0 2.442-.751l6.465-4.626c.371-.265.087-.842-.348-.706l-9.708 3.02-10.824-.949a5.95 5.95 0 0 1-3.934-1.975l-3.985-4.482a6 6 0 0 1-.746-1.049L66.963 38.323a2.38 2.38 0 0 0-2.17-1.217"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      d="m94.18 106.087 7.154 4.793a6 6 0 0 0 3.34 1.015h2.095M25.154 55.367l33.627 24.745"
    />
    <rect
      width={3.084}
      height={9.355}
      fill="#000"
      rx={1.542}
      transform="matrix(.9651 -.32918 .4761 .86398 51.412 53.41)"
    />
    <path
      fill="#E2E4EA"
      d="M54.567 51.004c.274.988.038 1.92-.384 2.717-.719 1.356-3.321.945-4.308-.426-.672-.935-.501-2.107.524-2.604 1.711-.83 3.717-1.316 4.168.313"
    />
    <path
      fill="#000"
      d="M51.4 54.4c-.294.01-.477.223-.408.476s.364.45.658.44zm4.049-1.506c.016-.246-.216-.495-.518-.556s-.56.088-.576.334zm-3.799 2.422c-.055.002-.093-.006-.045 0l.12.02c.106.017.256.04.431.058.348.035.812.051 1.285-.041.478-.094.963-.3 1.338-.702.374-.4.617-.97.67-1.758l-1.094-.221c-.044.662-.244 1.075-.487 1.335-.241.258-.548.39-.862.45-.32.064-.651.055-.926.027a6 6 0 0 1-.354-.047l-.136-.022c-.02-.003-.107-.017-.19-.014z"
    />
    <rect
      width={2.939}
      height={8.966}
      fill="#000"
      rx={1.469}
      transform="matrix(.9651 -.32918 .4761 .86398 58.663 51.523)"
    />
    <path
      fill="#E2E4EA"
      d="M56.553 51.298c1.257 1.435 3.396 1.887 4.9 2.026.949.088 1.783-.59 1.874-1.391a1.4 1.4 0 0 0-.28-.981l-.429-.589c-.873-1.197-2.476-1.94-3.949-1.57-1.758.441-3.227 1.237-2.116 2.505"
    />
    <path
      fill="#000"
      d="M62.82 52.224c.21-.165.547-.138.752.06.205.199.2.493-.01.658zm-4.368-.05c-.18-.216-.137-.506.096-.647a.6.6 0 0 1 .746.136zm5.11.768a3.87 3.87 0 0 1-1.83.707 3.4 3.4 0 0 1-1.619-.217c-.578-.23-1.141-.633-1.661-1.259l.842-.51c.42.506.83.78 1.192.923.361.143.711.171 1.035.136a2.85 2.85 0 0 0 1.299-.498z"
    />
    <rect
      width={1.95}
      height={3.83}
      fill="#fff"
      rx={0.975}
      transform="matrix(.4485 .87299 -.98425 .29259 57.481 59.28)"
    />
    <rect
      width={1.95}
      height={3.831}
      fill="#fff"
      rx={0.975}
      transform="matrix(.50702 .8529 -.94124 .3701 66.958 56.33)"
    />
    <path
      fill="#000"
      d="m66.971 63.553-.484.143zm-.356.38c.13.242.454.375.721.295.267-.079.378-.34.247-.582zm-5.682 1.848c.103.25.412.408.692.354s.422-.299.32-.548zm.116-1.045-.506.097zm2.317-3.136-.093-.461zm.06-.002.094.462zm-1.243.269-.303-.414zm4.304 1.83.128.236.968-.287-.128-.236zm-4.542 1.89-.39-.948-1.012.194.39.948zm1.514-3.525.06-.002-.185-.923-.06.002zm-.972.219c.292-.135.624-.21.972-.22l-.186-.922c-.5.014-.975.121-1.393.314zm4.968 1.129c-.754-1.396-2.434-2.322-4.121-2.273l.186.923c1.215-.035 2.424.631 2.967 1.636zm-5.9 1.229c-.393-.955-.009-1.926.932-2.358l-.607-.828c-1.35.62-1.9 2.012-1.337 3.38z"
    />
  </svg>
);
export default LegacyEmptyFallingAirplane;
